<div class="container">
  <app-promotion-messages-carousel
    *ngIf="!dataLayer?.alertMessages?.message"
  ></app-promotion-messages-carousel>
  <div
    class="api-commerce-dashboard"
    (click)="showOverviewPeriodsOptions(false); showPaymentsPeriodsOptions(false)"
  >
    <div class="overview card">
      <div class="header-section">
        <div class="operations-amounts">
          <div class="amount">
            <p class="quantity">
              {{ lastPaymentCurrency }}
              {{ lastPaymentAmount | formatCoinAmount : lastPaymentCurrency }}
            </p>
            <p class="label">Último pago</p>
          </div>
          <div class="amount">
            <p class="quantity">U$D {{ paymentsInTimeframeSum | formatCoinAmount : 'U$D' }}</p>
            <p class="label">Monto procesado {{ perdiodName[selectedOverviewPeriod] }}</p>
          </div>
        </div>
        <div class="option-selector-container">
          <div
            class="option-selector"
            (click)="showOverviewPeriodsOptions(!isOverviewPeriodsOpened); $event.stopPropagation()"
          >
            <p>{{ periodOptions[selectedOverviewPeriod] }}</p>
            <img class="expand-icon" src="/assets/icons/expand.svg" alt="expand" />
          </div>
          <div class="option-selector-content" *ngIf="isOverviewPeriodsOpened">
            <div class="option-item" (click)="selectOverviewPeriod('daily')">
              <div class="option-row">
                <p>{{ periodOptions.daily }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectOverviewPeriod('weekly')">
              <div class="option-row">
                <p>{{ periodOptions.weekly }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectOverviewPeriod('monthly')">
              <div class="option-row">
                <p>{{ periodOptions.monthly }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectOverviewPeriod('yearly')">
              <div class="option-row">
                <p>{{ periodOptions.yearly }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <ngx-charts-line-chart
          #chart
          [scheme]="colorScheme"
          [xAxis]="true"
          [yAxis]="true"
          [trimXAxisTicks]="false"
          [results]="history"
          [yScaleMax]="minMax.max"
          [yScaleMin]="minMax.min"
          [showGridLines]="true"
          [autoScale]="true"
          [rangeFillOpacity]="0"
          [maxXAxisTickLength]="chartPointsQuantity"
          [gradient]="false"
          style="fill: #8e8e8e"
        >
          <ng-template class="chart-tooltip" #tooltipTemplate let-model="model">
            <pre>U$D {{ model.value | formatCoinAmount : 'U$D' }}</pre>
          </ng-template>
          <ng-template class="chart-tooltip" #seriesTooltipTemplate let-model="model">
            <pre>U$D {{ model[0]?.value || 0 | formatCoinAmount : 'U$D' }}</pre>
          </ng-template>
        </ngx-charts-line-chart>
      </div>
    </div>
    <div class="balances-fiat">
      <div class="balances-amounts">
        <div class="balance">
          <img src="/assets/icons/flag-usd.svg" alt="flag-usd" />
          <p class="amount">
            U$D {{ authSvc.loggedUser.balance.fiat.USD | formatCoinAmount : 'U$D' }}
          </p>
        </div>
        <div class="balance">
          <img src="/assets/icons/flag-ars.svg" alt="flag-ars" />
          <p class="amount">
            AR$ {{ authSvc.loggedUser.balance.fiat.ARS | formatCoinAmount : 'AR$' }}
          </p>
        </div>
      </div>
    </div>
    <div class="portfolio card">
      <div class="header-section" (click)="openPortfolio(!isPortfolioOpened)">
        <p>Total</p>
        <div class="total-usd-portfolio">
          <p>U$D {{ cryptoBalanceInUsd | formatCoinAmount : 'U$D' }}</p>
          <button class="btn-show-portfolio">
            <img [class.reverse]="isPortfolioOpened" src="/assets/icons/expand.svg" alt="expand" />
          </button>
        </div>
      </div>
      <div [class.open]="isPortfolioOpened" class="coin-balances scrollable">
        <p class="empty-porfolio" *ngIf="!cryptoPortfolio.length">
          Aún no tenés criptomonedas en tu portfolio
        </p>
        <div class="coin-balance" *ngFor="let coin of cryptoPortfolio">
          <img src="/assets/icons/crypto/{{ coin.ticker | lowercase }}.svg" />
          <div class="data">
            <div class="title">
              <p class="complete">{{ coin.name }}</p>
              <p class="ticker">{{ coin.ticker }}</p>
            </div>
            <div class="balance">
              <p class="coin-amount">
                {{ coin.stocks | formatCoinAmount : coin.ticker }}
              </p>
              <p class="ars-amount">= AR$ {{ coin.balanceArs | formatCoinAmount : 'ARS' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="processed-payments card">
      <div class="header-section">
        <p class="title-section">Pagos procesados</p>
        <div class="option-selector-container">
          <div
            class="option-selector"
            (click)="showPaymentsPeriodsOptions(!isPaymentsPeriodsOpened); $event.stopPropagation()"
          >
            <p>{{ periodOptions[selectedPaymentsPeriod] }}</p>
            <img class="expand-icon" src="/assets/icons/expand.svg" alt="expand" />
          </div>
          <div class="option-selector-content" *ngIf="isPaymentsPeriodsOpened">
            <div class="option-item" (click)="selectPaymentsPeriod('daily')">
              <div class="option-row">
                <p>{{ periodOptions.daily }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectPaymentsPeriod('weekly')">
              <div class="option-row">
                <p>{{ periodOptions.weekly }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectPaymentsPeriod('monthly')">
              <div class="option-row">
                <p>{{ periodOptions.monthly }}</p>
              </div>
            </div>
            <div class="option-item" (click)="selectPaymentsPeriod('yearly')">
              <div class="option-row">
                <p>{{ periodOptions.yearly }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="charges?.length" class="payments-table scrollable">
        <div class="table">
          <div class="header">
            <p>ID</p>
            <p>Cliente</p>
            <p>Fecha</p>
            <p>Monto</p>
            <p>Estado</p>
          </div>
          <div class="body">
            <div class="item" *ngFor="let charge of charges">
              <div class="field" (click)="openChartDetails(charge.id)">{{ charge.id }}</div>
              <div class="field" (click)="openChartDetails(charge.id)">
                {{ charge.metadata?.client?.first_name || '-' }}
                {{ charge.metadata?.client?.last_name }}
              </div>
              <div class="field">
                {{ charge.creation_time | callback : getFormattedDate }}
              </div>
              <div class="field amount">
                {{ charge.price.currency | callback : addDolarSymbolToCoinName }}
                {{
                  +charge.price.amount
                    | formatCoinAmount : charge.price.currency
                    | callback : addDolarSymbolToCoinName
                }}
                <div class="fee-tooltip">
                  <img *ngIf="+charge.fee" src="assets/icons/info.svg" alt="info" class="fee-img" />
                  <div class="tooltip-content">
                    <div [outerHTML]="charge | getConvertedChargeFee"></div>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="status">
                  <div class="dot-container">
                    <div [class]="'dot ' + charge.status"></div>
                  </div>
                  <div class="status-text">
                    <p>{{ chargeStatusText[charge.status] }}</p>
                    <p
                      *ngIf="charge.status === 'UNDERPAID' && remainingChargeAmounts"
                      class="status-details"
                    >
                      Falta pagar
                      {{ remainingChargeAmounts[charge.id]?.currency || 0 }}
                      {{
                        remainingChargeAmounts[charge.id]?.amount || 0 | formatCoinAmount : 'ARS'
                      }}
                      <!-- MONEDA FORMATEADA COMO ARS PARA MOSTRAR SOLO 2 DECIMALES -->
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-list-message" *ngIf="!charges?.length">
        <p>No hay datos de éste período</p>
      </div>
      <div *ngIf="charges?.length" class="page-selector">
        <button (click)="selectPaymentsPage(selectedPaymentsPage - 1)" class="option prev"></button>
        <button
          *ngFor="let page of paymentsPages"
          (click)="selectPaymentsPage(page)"
          class="option"
          [class.selected]="selectedPaymentsPage === page"
        >
          {{ page }}
        </button>
        <button (click)="selectPaymentsPage(selectedPaymentsPage + 1)" class="option next"></button>
      </div>
    </div>
  </div>
</div>
